import { VStack } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { PrimaryCard } from "../components/common/cards";
import LoginForm from "../components/login/LoginForm";

/**
 * Renders the login page
 * 
 * @returns The login page
 */
const LoginPage = () => {
  const { t } = useTranslation();

  return (
    <PrimaryCard title={t("login.title")}>
      <VStack marginX={18} marginY={8}>
        <LoginForm />
      </VStack>
    </PrimaryCard>
  );
};

export default React.memo(LoginPage);
